import { useState, useEffect } from 'react';
import { useLocation, matchPath } from 'react-router-dom';

export function useRedeemCheck() {
  const [isFromRedeem, setIsFromRedeem] = useState<boolean>(false);

  let location = useLocation();
  useEffect(() => {
    const routePath = '/redeem/product/:productHandle/:action?';
    const matched = matchPath(location.pathname + location.hash, routePath);
    setIsFromRedeem(!!matched);
  }, [location]);

  return isFromRedeem;
}
